<template>
  <transition name="display">
    <div
      v-show="modelValue"
      class="appCurtain"
      :class="`theme-${theme}`"
      @click.self="$emit('update:modelValue', false)"
    >
      <transition name="slide">
        <div v-show="modelValue" class="appCurtain__area">
          <div class="appCurtain__head">
            <h3 class="appCurtain__title global-large-name">
              <slot name="title" />
            </h3>
            <button
              class="appCurtain__close"
              @click.self="$emit('update:modelValue', false)"
            >
              закрыть
            </button>
          </div>
          <div class="appCurtain__body">
            <slot name="default" />
            <div class="appCurtain__spinnerArea" v-if="loading">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="appCurtain__spinnerIcon"
              >
                <path
                  class="appCurtain__spinnerIconPath"
                  d="M10.4872 0.00010153C10.2667 0.00354785 10.0566 0.0943251 9.903 0.25251C9.74939 0.410695 9.66481 0.623365 9.66783 0.843842V4.17329C9.66627 4.28358 9.68664 4.39309 9.72777 4.49545C9.7689 4.5978 9.82997 4.69096 9.90741 4.76951C9.98486 4.84806 10.0771 4.91043 10.1789 4.953C10.2807 4.99558 10.3899 5.0175 10.5002 5.0175C10.6105 5.0175 10.7197 4.99558 10.8215 4.953C10.9232 4.91043 11.0155 4.84806 11.093 4.76951C11.1704 4.69096 11.2315 4.5978 11.2726 4.49545C11.3137 4.39309 11.3341 4.28358 11.3325 4.17329V0.843842C11.3341 0.732481 11.3132 0.621946 11.2713 0.518783C11.2293 0.41562 11.1671 0.321927 11.0882 0.243251C11.0094 0.164575 10.9156 0.102517 10.8124 0.0607515C10.7091 0.0189859 10.5985 -0.00163778 10.4872 0.00010153V0.00010153ZM15.0912 1.22751C14.9419 1.22646 14.795 1.2656 14.666 1.34083C14.537 1.41605 14.4306 1.52459 14.358 1.65507L12.6933 4.53744C12.6334 4.6322 12.5932 4.73808 12.5753 4.84872C12.5573 4.95937 12.5619 5.0725 12.5887 5.18134C12.6155 5.29018 12.664 5.39248 12.7313 5.48211C12.7987 5.57174 12.8834 5.64685 12.9804 5.70293C13.0775 5.75902 13.1849 5.79493 13.2961 5.8085C13.4074 5.82207 13.5203 5.81303 13.628 5.78193C13.7357 5.75082 13.836 5.69828 13.9229 5.62746C14.0097 5.55664 14.0814 5.46901 14.1336 5.36981L15.7984 2.48743C15.8737 2.36161 15.9144 2.21813 15.9164 2.07152C15.9185 1.9249 15.8818 1.78034 15.81 1.65248C15.7382 1.52461 15.6339 1.41797 15.5077 1.34334C15.3815 1.26872 15.2378 1.22876 15.0912 1.22751V1.22751ZM5.88481 1.22913C5.74051 1.2347 5.60014 1.27772 5.47749 1.35395C5.35484 1.43018 5.25413 1.53701 5.18525 1.66393C5.11638 1.79086 5.08171 1.93352 5.08464 2.0779C5.08758 2.22228 5.12803 2.36341 5.20201 2.48743L6.86674 5.36981C6.91893 5.46901 6.99063 5.55664 7.07752 5.62746C7.16441 5.69828 7.26471 5.75082 7.3724 5.78193C7.48009 5.81303 7.59296 5.82207 7.70423 5.8085C7.8155 5.79493 7.92288 5.75902 8.01993 5.70293C8.11699 5.64685 8.20172 5.57174 8.26903 5.48211C8.33635 5.39248 8.38488 5.29018 8.4117 5.18134C8.43851 5.0725 8.44307 4.95937 8.4251 4.84872C8.40713 4.73808 8.367 4.6322 8.30711 4.53744L6.64239 1.65507C6.5676 1.52118 6.45728 1.41055 6.3236 1.33539C6.18992 1.26023 6.03807 1.22346 5.88481 1.22913V1.22913ZM2.59276 4.58296C2.56511 4.58213 2.53744 4.58267 2.50985 4.58459C2.3304 4.59578 2.1594 4.66477 2.02243 4.78124C1.88545 4.89771 1.78987 5.0554 1.74998 5.23071C1.71008 5.40603 1.72802 5.58954 1.80111 5.75381C1.8742 5.91808 1.99851 6.05428 2.15544 6.14202L5.03782 7.80674C5.13257 7.86662 5.23845 7.90676 5.34909 7.92473C5.45974 7.9427 5.57287 7.93814 5.68171 7.91132C5.79055 7.8845 5.89285 7.83598 5.98248 7.76866C6.07211 7.70134 6.14722 7.61661 6.20331 7.51956C6.25939 7.42251 6.2953 7.31512 6.30887 7.20385C6.32245 7.09258 6.31341 6.97972 6.2823 6.87203C6.25119 6.76434 6.19865 6.66404 6.12783 6.57714C6.05702 6.49025 5.96938 6.41856 5.87018 6.36636L2.9878 4.70164C2.86816 4.62957 2.73231 4.58875 2.59276 4.58296V4.58296ZM18.4661 4.58459C18.3069 4.57939 18.1494 4.62001 18.0126 4.70164L15.1302 6.36636C15.031 6.41856 14.9434 6.49025 14.8725 6.57714C14.8017 6.66404 14.7492 6.76434 14.7181 6.87203C14.687 6.97972 14.6779 7.09258 14.6915 7.20385C14.7051 7.31512 14.741 7.42251 14.7971 7.51956C14.8532 7.61661 14.9283 7.70134 15.0179 7.76866C15.1075 7.83598 15.2098 7.8845 15.3187 7.91132C15.4275 7.93814 15.5406 7.9427 15.6513 7.92473C15.7619 7.90676 15.8678 7.86662 15.9626 7.80674L18.8449 6.14202C19.0031 6.05301 19.1279 5.91472 19.2002 5.74823C19.2726 5.58174 19.2885 5.39617 19.2456 5.21979C19.2027 5.0434 19.1033 4.88588 18.9626 4.7712C18.8219 4.65653 18.6476 4.591 18.4661 4.58459ZM1.34422 9.16745C1.23392 9.16589 1.12441 9.18627 1.02206 9.2274C0.919702 9.26853 0.826543 9.32959 0.747994 9.40704C0.669444 9.48449 0.60707 9.57677 0.564497 9.67853C0.521924 9.7803 0.5 9.8895 0.5 9.99981C0.5 10.1101 0.521924 10.2193 0.564497 10.3211C0.60707 10.4229 0.669444 10.5151 0.747994 10.5926C0.826543 10.67 0.919702 10.7311 1.02206 10.7722C1.12441 10.8134 1.23392 10.8337 1.34422 10.8322H4.67366C4.78396 10.8337 4.89347 10.8134 4.99582 10.7722C5.09817 10.7311 5.19133 10.67 5.26988 10.5926C5.34843 10.5151 5.4108 10.4229 5.45338 10.3211C5.49595 10.2193 5.51788 10.1101 5.51788 9.99981C5.51788 9.8895 5.49595 9.7803 5.45338 9.67853C5.4108 9.57677 5.34843 9.48449 5.26988 9.40704C5.19133 9.32959 5.09817 9.26853 4.99582 9.2274C4.89347 9.18627 4.78396 9.16589 4.67366 9.16745H1.34422ZM16.3267 9.16745C16.2164 9.16589 16.1069 9.18627 16.0046 9.2274C15.9022 9.26853 15.809 9.32959 15.7305 9.40704C15.6519 9.48449 15.5896 9.57677 15.547 9.67853C15.5044 9.7803 15.4825 9.8895 15.4825 9.99981C15.4825 10.1101 15.5044 10.2193 15.547 10.3211C15.5896 10.4229 15.6519 10.5151 15.7305 10.5926C15.809 10.67 15.9022 10.7311 16.0046 10.7722C16.1069 10.8134 16.2164 10.8337 16.3267 10.8322H19.6562C19.7665 10.8337 19.876 10.8134 19.9783 10.7722C20.0807 10.7311 20.1738 10.67 20.2524 10.5926C20.3309 10.5151 20.3933 10.4229 20.4359 10.3211C20.4785 10.2193 20.5004 10.1101 20.5004 9.99981C20.5004 9.8895 20.4785 9.7803 20.4359 9.67853C20.3933 9.57677 20.3309 9.48449 20.2524 9.40704C20.1738 9.32959 20.0807 9.26853 19.9783 9.2274C19.876 9.18627 19.7665 9.16589 19.6562 9.16745H16.3267ZM15.5675 12.0742C15.5399 12.0734 15.5122 12.0739 15.4846 12.0758C15.3052 12.087 15.1342 12.156 14.9972 12.2725C14.8602 12.389 14.7646 12.5466 14.7247 12.722C14.6848 12.8973 14.7028 13.0808 14.7759 13.2451C14.849 13.4093 14.9733 13.5455 15.1302 13.6333L18.0126 15.298C18.1073 15.3579 18.2132 15.398 18.3238 15.416C18.4345 15.4339 18.5476 15.4294 18.6565 15.4026C18.7653 15.3758 18.8676 15.3272 18.9572 15.2599C19.0469 15.1926 19.122 15.1079 19.1781 15.0108C19.2341 14.9138 19.2701 14.8064 19.2836 14.6951C19.2972 14.5838 19.2882 14.471 19.2571 14.3633C19.2259 14.2556 19.1734 14.1553 19.1026 14.0684C19.0318 13.9815 18.9441 13.9098 18.8449 13.8576L15.9626 12.1929C15.8429 12.1208 15.7071 12.08 15.5675 12.0742V12.0742ZM5.49139 12.0758C5.33211 12.0706 5.17469 12.1113 5.03782 12.1929L2.15544 13.8576C2.05624 13.9098 1.96861 13.9815 1.89779 14.0684C1.82697 14.1553 1.77443 14.2556 1.74332 14.3633C1.71221 14.471 1.70317 14.5838 1.71675 14.6951C1.73032 14.8064 1.76623 14.9138 1.82231 15.0108C1.8784 15.1079 1.95351 15.1926 2.04314 15.2599C2.13277 15.3272 2.23507 15.3758 2.34391 15.4026C2.45275 15.4294 2.56588 15.4339 2.67653 15.416C2.78717 15.398 2.89305 15.3579 2.9878 15.298L5.87018 13.6333C6.02838 13.5443 6.15316 13.406 6.22549 13.2395C6.29783 13.073 6.31376 12.8874 6.27086 12.711C6.22796 12.5347 6.12858 12.3771 5.98786 12.2625C5.84715 12.1478 5.6728 12.0822 5.49139 12.0758V12.0758ZM7.59993 14.2023C7.4506 14.2012 7.30375 14.2404 7.17475 14.3156C7.04575 14.3908 6.93936 14.4993 6.86674 14.6298L5.20201 17.5122C5.14213 17.607 5.102 17.7128 5.08402 17.8235C5.06605 17.9341 5.07061 18.0473 5.09743 18.1561C5.12425 18.2649 5.17277 18.3672 5.24009 18.4569C5.30741 18.5465 5.39214 18.6216 5.48919 18.6777C5.58625 18.7338 5.69363 18.7697 5.8049 18.7833C5.91617 18.7968 6.02903 18.7878 6.13672 18.7567C6.24442 18.7256 6.34472 18.673 6.43161 18.6022C6.5185 18.5314 6.59019 18.4438 6.64239 18.3446L8.30711 15.4622C8.38241 15.3364 8.42315 15.1929 8.42519 15.0463C8.42723 14.8997 8.39051 14.7551 8.31874 14.6272C8.24697 14.4994 8.1427 14.3927 8.01647 14.3181C7.89025 14.2435 7.74656 14.2035 7.59993 14.2023V14.2023ZM13.3761 14.2039C13.2318 14.2095 13.0914 14.2525 12.9687 14.3287C12.8461 14.4049 12.7454 14.5118 12.6765 14.6387C12.6076 14.7656 12.573 14.9083 12.5759 15.0527C12.5788 15.197 12.6193 15.3382 12.6933 15.4622L14.358 18.3446C14.4102 18.4438 14.4819 18.5314 14.5688 18.6022C14.6557 18.673 14.756 18.7256 14.8636 18.7567C14.9713 18.7878 15.0842 18.7968 15.1955 18.7833C15.3067 18.7697 15.4141 18.7338 15.5112 18.6777C15.6082 18.6216 15.693 18.5465 15.7603 18.4569C15.8276 18.3672 15.8761 18.2649 15.9029 18.1561C15.9298 18.0473 15.9343 17.9341 15.9164 17.8235C15.8984 17.7128 15.8582 17.607 15.7984 17.5122L14.1336 14.6298C14.0589 14.4959 13.9485 14.3853 13.8148 14.3101C13.6812 14.235 13.5293 14.1982 13.3761 14.2039V14.2039ZM10.4872 14.9826C10.2667 14.986 10.0566 15.0768 9.903 15.235C9.74939 15.3932 9.66481 15.6059 9.66783 15.8263V19.1558C9.66627 19.2661 9.68664 19.3756 9.72777 19.4779C9.7689 19.5803 9.82997 19.6735 9.90741 19.752C9.98486 19.8306 10.0771 19.8929 10.1789 19.9355C10.2807 19.9781 10.3899 20 10.5002 20C10.6105 20 10.7197 19.9781 10.8215 19.9355C10.9232 19.8929 11.0155 19.8306 11.093 19.752C11.1704 19.6735 11.2315 19.5803 11.2726 19.4779C11.3137 19.3756 11.3341 19.2661 11.3325 19.1558V15.8263C11.3341 15.715 11.3132 15.6044 11.2713 15.5013C11.2293 15.3981 11.1671 15.3044 11.0882 15.2257C11.0094 15.1471 10.9156 15.085 10.8124 15.0432C10.7091 15.0015 10.5985 14.9809 10.4872 14.9826V14.9826Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppCurtain",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    theme() {
      return (
        getComputedStyle(document.body)
          .getPropertyValue("--theme")
          .toString()
          .replace(/['"]+/g, "")
          .trim() || "dark"
      );
    },
  },
  provide() {
    return {
      startLoadingCurtain: () => (this.loading = true),
      stopLoadingCurtain: () => (this.loading = false),
    };
  },
  emits: ["update:modelValue"],
  watch: {
    modelValue(value) {
      if (value) {
        return (document.body.style.position = "fixed");
      }
      return (document.body.style.position = "");
    },
  },
};
</script>

<style lang="scss">
.slide-enter-active {
  animation-name: slideInUp;
  animation-duration: 0.4s;
}

.slide-leave-active {
  animation-name: slideOutDown;
  animation-duration: 0.4s;
}

@keyframes slideInUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideOutDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

.display-enter-active {
  animation-name: displayIn;
  animation-duration: 0.2s;
}

.display-leave-active {
  animation-name: displayOut;
  animation-duration: 0.4s;
}

@keyframes displayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes displayOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.appCurtain {
  position: fixed;
  bottom: 0;
  //background: var(--color-bg-80);
  background: rgba(0, 0, 0, 0.8);
  width: 100vw;
  display: flex;
  align-items: flex-end;
  z-index: 3;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}

.appCurtain__close {
  height: 32px;
  width: 32px;
  font-size: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.73641 0.263604C10.0879 0.615076 10.0879 1.18492 9.73641 1.5364L6.273 5L9.73641 8.46362C10.0586 8.7858 10.0854 9.29148 9.81695 9.64424L9.73641 9.73641C9.38494 10.0879 8.81509 10.0879 8.46362 9.73641L5 6.273L1.5364 9.73641C1.18492 10.0879 0.615076 10.0879 0.263604 9.73641C-0.0878679 9.38494 -0.0878679 8.81509 0.263604 8.46362L3.727 5L0.263604 1.5364C-0.0585786 1.21421 -0.0854272 0.708534 0.183058 0.355769L0.263604 0.263604C0.615076 -0.087868 1.18492 -0.087868 1.5364 0.263604L5 3.727L8.46362 0.263604C8.81509 -0.087868 9.38494 -0.087868 9.73641 0.263604Z' fill='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  border-radius: 50%;
  background-color: var(--color-black-50);
  position: absolute;
  top: 13px;
  right: 15px;
}

.appCurtain__title {
  margin-bottom: 0;
  color: var(--color-text);
}

.appCurtain__area {
  background: var(--color-tile);
  border-radius: 14px 14px 0 0;
  width: 100%;
  max-height: calc(100% - 20px);
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.appCurtain__head {
  display: flex;
  padding: 20px 20px 0;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.appCurtain__body {
  padding: 0;
  position: relative;
}

.appCurtain__spinnerArea {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: var(--color-tile);
  display: flex;
  align-items: center;
  justify-content: center;
}

.appCurtain__spinnerIconPath {
  animation: rotation 2s infinite linear;
  transform-origin: center;
  fill: var(--color-text);
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

@include media-breakpoint-up(sm) {
  .appCurtain {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .appCurtain__head {
    padding: 30px 30px 0;
  }
  .appCurtain__area {
    border-radius: 14px;
    max-width: 480px;
  }
}
</style>
